import React from "react";

export const DEVICES_PAGE_TITLE = "Devices";

const isMissing = (val) =>
  val === null || val === undefined || val === "" || val === "NA";

const firstDefined = (...vals) => vals.find((v) => !isMissing(v));

export const deviceTableColumns = [
  {
    key: "device_name",
    header: "Name",
    wrap: true,
    render: (row) => (
      <>
        <div
          title={row.device_name}
          style={{
            fontWeight: 600,
            fontSize: "14px",
            color: "#1e293b",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {row.device_name}
        </div>
        {row.csv_file_name && row.csv_file_name !== "NA" && (
          <div
            title={row.csv_file_name}
            style={{
              fontSize: "12px",
              color: "#64748b",
              marginTop: "2px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {row.csv_file_name}
          </div>
        )}
        {Array.isArray(row.coupled_device_names) && row.coupled_device_names.length > 0 && (
          <div
            title={`Coupled: ${row.coupled_device_names.join(", ")}`}
            style={{
              fontSize: "12px",
              color: "#64748b",
              marginTop: "2px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            Coupled: {row.coupled_device_names.join(", ")}
          </div>
        )}
      </>
    ),
  },
  {
    key: "deviceCategory",
    header: "Type",
    align: "center",
    width: "130px",
    hideBelow: "md",
    render: (row) => {
      const category = (row.deviceCategory || "").toLowerCase();
      return (
        <span className={`device-badge device-badge-${category}`}>
          {row.deviceCategory}
        </span>
      );
    },
  },
  {
    key: "min_power",
    header: "Min Power",
    align: "right",
    width: "100px",
    hideBelow: "xl",
    render: (row) => {
      let val;
      if (row.deviceCategory === "Storage") {
        val = row.max_power_charging;
      } else if (row.deviceCategory === "Production") {
        val = row.min_power_charging;
      } else {
        val = null;
      }
      if (isMissing(val)) return <span style={{ color: "#94a3b8" }}>&mdash;</span>;
      return (
        <span style={{ fontVariantNumeric: "tabular-nums" }}>
          {val} <span style={{ color: "#64748b", fontSize: "12px" }}>kW</span>
        </span>
      );
    },
  },
  {
    key: "max_power",
    header: "Max Power",
    align: "right",
    width: "100px",
    hideBelow: "lg",
    render: (row) => {
      const val =
        row.deviceCategory === "Storage"
          ? row.max_power_discharging
          : firstDefined(row.max_power_charging, row.peakPower);
      if (isMissing(val)) return <span style={{ color: "#94a3b8" }}>&mdash;</span>;
      return (
        <span style={{ fontVariantNumeric: "tabular-nums" }}>
          {val} <span style={{ color: "#64748b", fontSize: "12px" }}>kW</span>
        </span>
      );
    },
  },
  {
    key: "max_capacity",
    header: "Max Capacity",
    align: "right",
    width: "120px",
    hideBelow: "xxl",
    render: (row) => {
      const val = row.deviceCategory === "Storage" ? row.max_energy : null;
      if (isMissing(val)) return <span style={{ color: "#94a3b8" }}>&mdash;</span>;
      return (
        <span style={{ fontVariantNumeric: "tabular-nums" }}>
          {val} <span style={{ color: "#64748b", fontSize: "12px" }}>kWh</span>
        </span>
      );
    },
  },
  {
    key: "status",
    header: "Status",
    align: "center",
    width: "150px",
    render: (row) => (
      <span
        className={`status-pill ${row.status === "connected" ? "status-pill-connected" : "status-pill-disconnected"}`}
        title={row.status === "connected" ? "Included in simulation runs" : "Excluded from simulation runs"}
      >
        <i
          className={`fa-solid ${row.status === "connected" ? "fa-circle-check" : "fa-circle-xmark"} status-pill-icon`}
          aria-hidden="true"
        />
        {row.status === "connected" ? "Connected" : "Not Connected"}
      </span>
    ),
  },
];
